/**
 * newPage — which page the Practice Ops route renders, asked by everything that must agree with it.
 *
 * WHY THIS EXISTS (2026-10-30). The /app/practice-pulse route component (pages/PracticePulse/PracticeOpsRoute.js) renders the NEW
 * Practice Ops page or the classic Practice Pulse page, decided by shouldUseNewFollowupsUi('practiceOps', …). The full-screen views
 * (the Wall and the Operatory) hide the app shell (Layout.vue) and the Agent button (App.vue) ONLY when the new page is what the route
 * renders — so those two ask THIS function, the route component asks THIS function, and the three cannot disagree.
 *
 *   practiceOpsUsesNewPage({ isSuperAdmin, userKey, storage })    the gate's answer for this person
 *   fullScreenViewFor(route, { isSuperAdmin, userKey, storage })  wallShell.js isFullScreenView for a vue-router `$route`
 */
import { shouldUseNewFollowupsUi } from '@/utils/followups/uiVersion';
import { isFullScreenView } from '@/utils/practiceOps/wallShell';

export function practiceOpsUsesNewPage({ isSuperAdmin, userKey, storage } = {}) {
  return shouldUseNewFollowupsUi('practiceOps', { isSuperAdmin, userKey, storage });
}

export function fullScreenViewFor(route, person) {
  const r = route && typeof route === 'object' ? route : {};
  // the cheap checks first: nearly every route is not the Practice Ops one, and the gate reads storage
  if (!isFullScreenView({ routeName: r.name, query: r.query, usesNewPage: true })) return false;
  return isFullScreenView({ routeName: r.name, query: r.query, usesNewPage: practiceOpsUsesNewPage(person) });
}
